import { Box } from '@zillow/constellation-10';

import { LoadingButton, LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

/** Shaped like Persona's start page, and shared with the surfaces that wait on `startOrResume`. */
const PersonaInquirySkeleton = () => (
  <Box
    data-testid="PersonaInquirySkeleton"
    css={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'default',
      paddingBlockStart: '800',
      paddingInline: '400',
      width: '100%',
    }}
  >
    <LoadingHeading isLoading={true} level={2} textStyle="heading-sm" loadingWidth="240px">
      &nbsp;
    </LoadingHeading>
    <LoadingParagraph isLoading={true} textStyle="body-sm" loadingWidth="min(420px, 100%)">
      &nbsp;
    </LoadingParagraph>
    <LoadingParagraph isLoading={true} textStyle="body-sm" loadingWidth="min(340px, 100%)">
      &nbsp;
    </LoadingParagraph>
    <LoadingButton isLoading={true} loadingWidth="180px">
      &nbsp;
    </LoadingButton>
  </Box>
);

export default PersonaInquirySkeleton;
